'use strict';

/**
 * auxiliary function to calculate the distance
 * @param {float} deg degrees
 * @returns {float} radius
 */
function deg2rad(deg) {
    return deg * (Math.PI / 180);
}

/**
 *
 * @param {Object} position the current position of the client
 * @param {float} lat2 latitude of the store
 * @param {float} lon2 longitude of the store
 * @returns {float} the distance between the client and the store
 */
function getDistanceFromLatLon(position, lat2, lon2) {
    var lat1 = position.coords.latitude;
    var lon1 = position.coords.longitude;

    var R = 6371; // Radius of the earth in km
    var dLat = deg2rad(lat2 - lat1); // deg2rad below
    var dLon = deg2rad(lon2 - lon1);

    /* eslint-disable no-mixed-operators */
    var a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(deg2rad(lat1)) *
            Math.cos(deg2rad(lat2)) *
            Math.sin(dLon / 2) *
            Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c; // Distance in km
    var dmi = Math.round(d * 0.621371192); // Distance in miles
    /* eslint-enable no-mixed-operators */

    return {
        mi: dmi,
        km: Math.round(d)
    };
}

module.exports = {
    getDistanceFromLatLon: getDistanceFromLatLon
};
